module.exports = __webpack_public_path__ + "0e77c311f2d0392e5b120a26393d35d5.png";